
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLocationJob = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 6.3a3.2 3.2 0 1 1 0 6.4 3.2 3.2 0 0 1 0-6.4Z",
  stroke: "#787878",
  strokeWidth: 1.6
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 2.3c1.896 0 3.724.79 5.077 2.212C18.432 5.934 19.2 7.872 19.2 9.9c0 2.553-1.6 5.388-3.379 7.711a32.6 32.6 0 0 1-3.303 3.679q-.164.154-.262.241l-.098.086-.022.017-.02.018A.17.17 0 0 1 12 21.7a.2.2 0 0 1-.058-.01l-.057-.038A33 33 0 0 1 8.188 17.6C6.406 15.275 4.8 12.447 4.8 9.9c0-2.028.768-3.966 2.123-5.388C8.276 3.09 10.103 2.3 12 2.3Z",
  stroke: "#787878",
  strokeWidth: 1.6
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M12 6.3a3.2 3.2 0 1 1 0 6.4 3.2 3.2 0 0 1 0-6.4Z\" stroke=\"#787878\" stroke-width=\"1.6\"/><path d=\"M12 2.3c1.896 0 3.724.79 5.077 2.212C18.432 5.934 19.2 7.872 19.2 9.9c0 2.553-1.6 5.388-3.379 7.711a32.6 32.6 0 0 1-3.303 3.679q-.164.154-.262.241l-.098.086-.022.017-.02.018A.17.17 0 0 1 12 21.7a.2.2 0 0 1-.058-.01l-.057-.038A33 33 0 0 1 8.188 17.6C6.406 15.275 4.8 12.447 4.8 9.9c0-2.028.768-3.966 2.123-5.388C8.276 3.09 10.103 2.3 12 2.3Z\" stroke=\"#787878\" stroke-width=\"1.6\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/LocationJob.0f425276bd8e956c89be91871fd7a87c.svg"),
        {
          React: SvgLocationJob,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      